<template>
  <section class="container">
    <div class="profile-header">

      <div id="context" ref="context">
          <template v-for="(chat, idx) in messages">
              <div class="chat-list-owner bubble" :key="idx">
                <div class="list-item-owner">
                  <p>
                  {{ chat }}
                  </p>
                </div>
              </div>
          </template>

          <!-- <template v-for="(chat, idx) in messages">
            <template v-for="(list, idx) in chat.message">

              <template v-if="list.uid == uid">

                <div class="chat-list-owner bubble" :key="idx">

                <div class="list-item-owner">
                  <p>
                  {{ list.message }}
                  </p>
                </div>
                <router-link :to="'/user/' + list.uid">
                <div class="chat-photo-owner" >
                  <template v-if="list.ownerPhotoURL != null">
                    <img :src="list.ownerPhotoURL">
                  </template>
                  <template v-else>
                    <img src="../assets/icons/user-01.svg">
                  </template>
                </div>
                </router-link>
                </div>

              </template>

              <template v-else>
                <div class="chat-list bubble" :key="idx">
                  <router-link :to="'/user/' + list.uid">
                  <div class="chat-photo" >
                    <template v-if="list.ownerPhotoURL != null">
                      <img :src="list.ownerPhotoURL">
                    </template>
                    <template v-else>
                      <img src="../assets/icons/user-01.svg">
                    </template>
                  </div>
                  </router-link>

                <div class="list-item">
                  <p>
                  {{ list.message }}
                  </p>
                </div>

                </div>
              </template>

            </template>
          </template> -->
        <input @keyup.enter="pushFireChat(messageBody)" class="message" type="text" placeholder="Message..." v-model="messageBody">

      </div>
    </div>
  </section>
</template>

<script>
import { firestore } from '../main'
import firebase from 'firebase'
import { mapMutations, mapGetters } from 'vuex'

export default {
  name: 'profile',
  data () {
    return {
      chatData: [],
      boom: 'unselected',
      user: [],
      messageBody: '',
      pageId: '',
      photoURL: '',
      urlPath: '',
      messageId: '',
    //   messages: [],
      gallery: []
    }
  },
  firestore () {

    this.activePage  = this.$route.path.split('/messages/')[1]

      return {
        user: firestore.collection('users').doc(this.activePage),
        // messages: firestore.collection('messages').where('id', '==', this.activePage)
      }
  },
  computed: {
    getState() {
      return this.$store.state;
    },
    ...mapGetters([
      'loggedIn',
      'user',
      'isLoading',
      'messages',
      'activePatient'
    ])
  },
  methods: {
    pushChat (message) {
      this.chatData.push({
        id: message
      })
      this.messageBody = ''
    },
    pushFireChat (payload) {
        const createdAt = new Date()

        this.messages.push(payload)
        // const messageData = {
        //   message: message,
        //   timeStamp: createdAt,
        //   ownerPhotoURL: this.user.photoURL,
        //   uid: this.user.uid,
        //   ownerEmail: this.currentUser,
        //   modified: createdAt
        // }

        // const pushCreate = {
        //   createdAt: createdAt,
        //   id: this.urlPath,
        //   uid: userUID,
        //   creatorUID: this.user.uid,
        //   creatorEmail: creatorEmail,
        //   latestMessage: message,
        //   ownerPhotoURL: this.user.photoURL,
        //   message: firebase.firestore.FieldValue.arrayUnion(messageData)
        // }

        // const pushChanges = {
        //   latestMessage: message,
        //   message: firebase.firestore.FieldValue.arrayUnion(messageData)
        // }

        // firestore.collection('messages').doc(this.urlPath).get()
        //   .then(data => {
        //     if (data.exists) {
        //       firestore.collection('messages').doc(this.urlPath).update(pushChanges)
        //     } else {
        //       firestore.collection('messages').doc(this.urlPath).set(pushCreate)
        //     }
        //   })
        this.messageBody = ''
      }
  }
}
</script>
<style lang="scss" scoped>

@keyframes chat {
  0% {
    width: 0;
  }

  100% {
    width: auto;
    padding: 10px 20px;
  }
}

#context {
  text-align: left;
  margin: 3em auto 6em auto;
  line-height: 2em;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.bubble {
  /* border: 1px solid blue;

display: flex;
flex: 1 1 85%;
flex-wrap: wrap;
align-items: flex-start;
align-content: flex-start;
overflow: auto; */
}

.chat-list {
  padding: 0 5px;
  width: auto;
  display: flex;
  flex-flow: row;
}
.chat-list img {
  width: 25px;
  border-radius: 50%;
}
.chat-list .list-item {
  margin: 0 0 10px 0;
  font-size: 18px;
  line-height: 1.1em;
  width: 0;
  max-width: 70%;
  background-color: #fff;
  padding: 0;
  border-radius: 20px;
  color: #232535;
  margin-left: 1em;
  overflow: hidden;
  animation: chat .5s forwards;
  transition: all .5s ease-in-out;
}

.chat
 .list-item p {
  padding: 0;
  margin: 0;
}
.chat-list-owner .list-item-owner p {
  padding: 0;
  margin: 0;
}

.chat-photo {
  border-radius: 50%;
  margin-left: 1em;
}
.chat-container {
  height: auto;
  overflow-y: scroll;
}

/* change chat */

.chat-list-owner {
//   margin-right: 1em;
  display: flex;
  flex-flow: row;
  justify-content: flex-end;
  position: relative;
  z-index: 999;
//   width: 100%;
}
.chat-list-owner img {
  width: 25px;
  border-radius: 50%;
}
.chat-list-owner .list-item-owner {
  margin: 0 0 10px 0;
  font-size: 18px;
  line-height: 1.1em;
  width: auto;
  max-width: 70%;
  background-color: transparent;
  border: 1px solid #fff;
  /* background-color: #966B4D; */
  padding: 0;
  border-radius: 20px;
  color: white;
  margin-right: 1em;
  animation: chat .2s forwards;
  transition: all .2s ease-in-out;
  overflow: hidden;
}
.chat-list-owner .list-item-owner p {
  padding: 0;
  margin: 0;
}

.chat-photo-owner {
  border-radius: 50%;
}
.chat-container-owner {
  height: auto;
  overflow-y: scroll;
}

img.chat-artwork {
  width: 40%;
  height: 50%;
  margin: 0 auto 0 5%;
  border-radius: 0;
}

.context-icon {
  width: 15px;
  margin-right: 20px;
}

.container {
  display: flex;
}

.container input[type="text"],
.container input[type="date"],
.container input[type="datetime"],
.container input[type="email"],
.container input[type="number"],
.container input[type="search"],
.container input[type="time"],
.container input[type="url"],
.container input[type="password"],
.container textarea,
.container select {
    font-family: "source sans pro", sans-serif;
    letter-spacing: 2px;
    font-weight: lighter;
    color: #fff;
    background: transparent;
    border: 1px solid #fff;
    position: fixed;
    bottom: 20px;
    left: 50%;
    border-radius: 50px;
    font-size: 18px;
    margin: 0 auto;
    margin-left: -45%;
    outline: 0;
    padding: 15px 7px 15px 25px;
    width: 90%;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-shadow: 0 1px 0 rgba(0,0,0,0.03) inset;
    background-size: 40px 40px;

    &::placeholder {
        color: #fff;
    }
}

.profile-container {
  flex-flow: row;
  width: 60%;
  margin: 2em auto;
  height: auto;
  padding: 0;
}
.profile-header {
  width: 100%;

}

.user-image {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: inline-block;
}

</style>



// WEBPACK FOOTER //
// src/components/Messages.vue